import * as React from 'react';
import { GroupOptionItem } from '../../components/GroupOptionItem';

import femaleUnselected from '../../assets/groupOption/unselectedBottom/group-option-female-unselected.svg';
import hasGlassesUnselected from '../../assets/groupOption/unselectedBottom/group-option-glasses-unselected.svg';
import maleUnselected from '../../assets/groupOption/unselectedBottom/group-option-male-unselected.svg';
import noGlassesUnselected from '../../assets/groupOption/unselectedBottom/group-option-noglasses-unselected.svg';
import eyeUnselected from '../../assets/groupOption/unselectedTop/group-option-eye-unselected.svg';
import sexUnselected from '../../assets/groupOption/unselectedTop/group-option-gender-unselected.svg';
import glassesUnselected from '../../assets/groupOption/unselectedTop/group-option-glasses-unselected.svg';
import hairUnselected from '../../assets/groupOption/unselectedTop/group-option-hair-unselected.svg';
import hairmaleUnselected from '../../assets/groupOption/unselectedTop/group-option-hairmale-unselected.svg';
import moustacheUnselected from '../../assets/groupOption/unselectedTop/group-option-moustache-unselected.svg';
import skincolorUnselected from '../../assets/groupOption/unselectedTop/group-option-skincolor-unselected.svg';
import birthdayUnselected from '../../assets/groupOption/unselectedTop/group-option-birthday-unselected.svg';

import femaleSelected from '../../assets/groupOption/selectedBottom/group-option-female-selected.svg';
import hasGlassesSelected from '../../assets/groupOption/selectedBottom/group-option-glasses-selected.svg';
import maleSelected from '../../assets/groupOption/selectedBottom/group-option-male-selected.svg';
import noGlassesSelected from '../../assets/groupOption/selectedBottom/group-option-noglasses-selected.svg';
import eyeSelected from '../../assets/groupOption/selectedTop/group-option-eye-selected.svg';
import sexSelected from '../../assets/groupOption/selectedTop/group-option-gender-selected.svg';
import glassesSelected from '../../assets/groupOption/selectedTop/group-option-glasses-selected.svg';
import hairSelected from '../../assets/groupOption/selectedTop/group-option-hair-selected.svg';
import hairmaleSelected from '../../assets/groupOption/selectedTop/group-option-hairmale-selected.svg';
import moustacheSelected from '../../assets/groupOption/selectedTop/group-option-moustache-selected.svg';
import skincolorSelected from '../../assets/groupOption/selectedTop/group-option-skincolor-selected.svg';
import birthdaySelected from '../../assets/groupOption/selectedTop/group-option-birthday-selected.svg';

//Baka
import bakaGenderUnselected from '../../assets/groupOption/baka/BAKA_ikona_web-01.svg';
import bakaGenderSelected from '../../assets/groupOption/baka/BAKA_ikona_web-02.svg';

import bakaFemaleUnselected from '../../assets/groupOption/baka/BAKA_ikona_web_odabrano-02.svg';
import bakaFemaleSelected from '../../assets/groupOption/baka/BAKA_ikona_web_odabrano-04.svg';

import bakaMaleUnselected from '../../assets/groupOption/baka/BAKA_ikona_web_odabrano-01.svg';
import bakaMaleSelected from '../../assets/groupOption/baka/BAKA_ikona_web_odabrano-03.svg';

import dudaUnselected from '../../assets/groupOption/unselectedTop/DUDA_IKONE_08.svg';
import dudaSelected from '../../assets/groupOption/selectedTop/DUDA_IKONE_01.svg';

import stuffedAnimalSelected from '../../assets/groupOption/selectedTop/PLISANCI-01_selected.svg';
import stuffedAnimalUnSelected from '../../assets/groupOption/unselectedTop/PLISANCI-03_unselected.svg';

const unselectedIcons: Record<string, string> = {
  beard: moustacheUnselected,
  eye: eyeUnselected,
  female: femaleUnselected,
  glasses: glassesUnselected,
  hair: hairUnselected,
  hairmale: hairmaleUnselected,
  hasGlasses: hasGlassesUnselected,
  male: maleUnselected,
  noGlasses: noGlassesUnselected,
  race: skincolorUnselected,
  sex: sexUnselected,
  birthday: birthdayUnselected,
  baka: bakaGenderUnselected,
  bakaf: bakaFemaleUnselected,
  bakam: bakaMaleUnselected,
  pacifier: dudaUnselected,
  stuffed: stuffedAnimalUnSelected,
};

const selectedIcons: Record<string, string> = {
  beard: moustacheSelected,
  eye: eyeSelected,
  female: femaleSelected,
  glasses: glassesSelected,
  hair: hairSelected,
  hairmale: hairmaleSelected,
  hasGlasses: hasGlassesSelected,
  male: maleSelected,
  noGlasses: noGlassesSelected,
  race: skincolorSelected,
  sex: sexSelected,
  birthday: birthdaySelected,
  baka: bakaGenderSelected,
  bakaf: bakaFemaleSelected,
  bakam: bakaMaleSelected,
  pacifier: dudaSelected,
  stuffed: stuffedAnimalSelected,
};

export function GenerateGroupOptionItem(
  item: string,
  isSelected: boolean,
  key: string | number,
  onSelectedItem: (item: string) => void,
  bookId?: number,
  avatar?: any,
) {
  let icon = isSelected ? selectedIcons[item] : unselectedIcons[item];

  //grandmother_character
  //Jako jako zajebana stvar
  if (
    (bookId === 47 ||
      bookId === 48 ||
      bookId === 49 ||
      bookId === 50 ||
      bookId === 51 ||
      bookId === 52 ||
      bookId === 57) &&
    avatar.uid === 'grandmother_character'
  ) {
    if (item === 'sex') {
      icon = isSelected ? selectedIcons['baka'] : unselectedIcons['baka'];
    }

    if (item === 'female') {
      icon = isSelected ? selectedIcons['bakaf'] : unselectedIcons['bakaf'];
    }

    if (item === 'male') {
      icon = isSelected ? selectedIcons['bakam'] : unselectedIcons['bakam'];
    }
  }

  if (icon) {
    return <GroupOptionItem key={key} item={icon} onClick={onSelectedItem.bind(null, item)} />;
  }
}
